import Styled from 'styled-components';

import { VALID_COLOR } from '../../lib/StyledComponents';

export interface IBannerProps {
  bannerStyle?: VALID_COLOR;
  padding?: string;
}

export const BannerSection = Styled.div<IBannerProps>`
  padding: 1em;
  font-weight: 700;
  font-size: 1.2rem;
  background-color: ${({ theme: { bannerSection } }) => bannerSection.colorBackground};
`;

BannerSection.displayName = 'BannerSection';
